// extracted by mini-css-extract-plugin
export default {"gradient-container":"GradientContainer_gradient-container__FcOlC","scrollable-container":"GradientContainer_scrollable-container__jCiSO"};